<template>
  <div class="vx-row justify-content-center mt-1 mb-2">
    <div class="vx-col w-1/3">
      <div class="justify-content-center">
        <div class="w-full p-1">
          <vs-progress class="items-left" :height="6" :percent="relevancy" color="#9DCD5B"></vs-progress>
          <div class="w-full text-center">
            <span style="font-size: 0.8rem;">{{relevancy}}% {{ $t("components.progressMeasureHorizontal.pmh1") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <div class="justify-content-center">
        <div class="w-full p-1">
          <vs-progress class="items-left" :height="6" :percent="progress" color="#76C488"></vs-progress>
          <div class="w-full text-center">
            <span style="font-size: 0.8rem;">{{progress}}% {{ $t("components.progressMeasureHorizontal.pmh2") }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <div class="justify-content-center">
        <div class="w-full p-1">
          <vs-progress class="items-left" :height="6" :percent="practice" color="#079E9A"></vs-progress>
          <div class="w-full text-center">
            <span style="font-size: 0.8rem;">{{practice}}% {{ $t("components.progressMeasureHorizontal.pmh3") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ProgressMeasureHorizontal",
    props: ["progress", "practice", "relevancy"],
    components: {},
    methods: {},
    // props: ['relevancy', 'progress', 'practice'],
    data() {
      return {
        fill: { gradient: ["green"] },
        rel: [this.relevancy],
        prog: [this.progress],
        prac: [this.practice]
      };
    }
  };
</script>

<style scoped>
  .justify-content-center {
    justify-content: center;
  }

  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }
</style>
